(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["calendar-story"] && !Shopify.designMode) return;
  try {
    

function initCalendar(root){
 if(root.dataset.ready)return;root.dataset.ready='true';
 const track=root.querySelector('.bc-gallery'),controls=root.querySelector('.bc-review-controls');
 if(!track||!controls)return;
 const range=controls.querySelector('input'),page=controls.querySelector('.bc-review-page'),prev=controls.querySelector('[data-bc-review-dir="-1"]'),next=controls.querySelector('[data-bc-review-dir="1"]');
 function sync(){const max=track.scrollWidth-track.clientWidth;const pos=Math.min(max,Math.max(0,track.scrollLeft));const visible=Math.max(1,Math.round(track.clientWidth/(track.firstElementChild.getBoundingClientRect().width+20)));const pages=Math.ceil(track.children.length/visible);range.value=max>0?Math.round(pos/max*100):0;prev.disabled=pos<2;next.disabled=pos>=max-2;page.textContent=`${max>0?Math.round(pos/max*(pages-1))+1:1} / ${pages}`}
 controls.querySelectorAll('button').forEach(b=>b.addEventListener('click',()=>track.scrollBy({left:Number(b.dataset.bcReviewDir)*(track.clientWidth+20),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})));
 range.addEventListener('input',()=>{track.scrollLeft=(track.scrollWidth-track.clientWidth)*Number(range.value)/100});
 track.addEventListener('scroll',sync,{passive:true});new ResizeObserver(sync).observe(track);sync();
}
document.querySelectorAll('#bc26').forEach(initCalendar);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('#bc26').forEach(initCalendar));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luckysong-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('luckysong-videos')) {
  customElements.define('luckysong-videos', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.track = this.querySelector('.ls-video-grid');
      this.cards = [...this.querySelectorAll('.ls-video-card')];
      this.videos = this.cards.map(card => card.querySelector('video'));
      this.prev = this.querySelector('.ls-video-prev');
      this.next = this.querySelector('.ls-video-next');
      this.dots = this.querySelector('.ls-video-dots');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.reconcile = () => {
        const track = this.track.getBoundingClientRect();
        this.videos.forEach(video => {
          const r = video.getBoundingClientRect();
          const horizontal = Math.max(0, Math.min(r.right,track.right) - Math.max(r.left,track.left));
          const vertical = Math.max(0, Math.min(r.bottom,innerHeight) - Math.max(r.top,0));
          const active = !document.hidden && horizontal >= r.width * .85 && vertical > Math.min(120,r.height * .2);
          if (!active || video.dataset.userPaused === 'true') {
            video.pause();
            return;
          }
          const source = video.querySelector('source');
          if (!source.src) {
            video.muted = true;
            video.defaultMuted = true;
            source.src = source.dataset.src;
            video.load();
          }
          if (video.paused) video.play().catch(() => this.setState(video));
        });
      };
      this.setState = video => {
        const card = video.closest('.ls-video-card');
        const button = card.querySelector('.ls-video-toggle');
        const playing = !video.paused;
        card.classList.toggle('is-playing',playing);
        button.setAttribute('aria-label',playing ? button.dataset.pauseLabel : button.dataset.playLabel);
        button.querySelector('span').textContent = playing ? 'Ⅱ' : '▶';
      };
      this.step = () => this.cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).gap);
      this.go = index => this.track.scrollTo({left:index*this.step(),behavior:this.motion.matches ? 'instant' : 'smooth'});
      this.update = () => {
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.prev.disabled = this.track.scrollLeft < 2;
        this.next.disabled = this.track.scrollLeft >= max - 2;
        const pages = Math.round(max/this.step())+1;
        if (this.dots.children.length !== pages) {
          this.dots.replaceChildren();
          for (let i=0;i<pages;i++) {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'ls-video-dot';
            button.setAttribute('aria-label',this.track.getAttribute('aria-label')+' '+(i+1));
            button.addEventListener('click',()=>this.go(i),{signal});
            this.dots.append(button);
          }
        }
        const index = Math.round(this.track.scrollLeft/this.step());
        [...this.dots.children].forEach((dot,i)=>dot.setAttribute('aria-current',i===index ? 'true' : 'false'));
        this.reconcile();
      };
      this.prev.addEventListener('click',()=>this.go(Math.round(this.track.scrollLeft/this.step())-1),{signal});
      this.next.addEventListener('click',()=>this.go(Math.round(this.track.scrollLeft/this.step())+1),{signal});
      this.track.addEventListener('keydown',event=>{
        if (event.target !== this.track || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        this.go(Math.round(this.track.scrollLeft/this.step())+(event.key==='ArrowRight'?1:-1));
      },{signal});
      this.track.addEventListener('scroll',()=>{
        if(this.frame) return;
        this.frame=requestAnimationFrame(()=>{this.frame=0;this.update()});
      },{signal,passive:true});
      this.videos.forEach(video=>{
        video.muted = true;
        video.defaultMuted = true;
        video.pause();
        ['play','pause','error'].forEach(name=>video.addEventListener(name,()=>this.setState(video),{signal}));
        video.addEventListener('loadeddata',this.reconcile,{signal});
        video.closest('.ls-video-card').querySelector('button').addEventListener('click',()=>{
          if(!video.paused){video.dataset.userPaused='true';video.pause()}
          else {delete video.dataset.userPaused;this.reconcile()}
        },{signal});
      });
      this.observer = new IntersectionObserver(this.reconcile,{threshold:[0,.1,.25,.5,.75,1]});
      this.cards.forEach(card=>this.observer.observe(card));
      this.resize = new ResizeObserver(this.update);
      this.resize.observe(this.track);
      document.addEventListener('visibilitychange',this.reconcile,{signal});
      this.update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller=null;
      this.observer?.disconnect();
      this.resize?.disconnect();
      if(this.frame) cancelAnimationFrame(this.frame);
      this.videos?.forEach(video=>video.pause());
    }
  });
}

if (!customElements.get('luckysong-comparison')) {
  customElements.define('luckysong-comparison', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const slider = this.querySelector('input[type="range"]');
      if (slider) slider.addEventListener('input', () => this.style.setProperty('--ls-position', slider.value + '%'));
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
